export enum AddressTypes {
  PRIMARY = 'PRIMARY',
  CORRESPONDENCE = 'CORRESPONDENCE'
}
